module.exports = __webpack_public_path__ + "static/media/12.60624ec1.jpg";